export default function useSetMapCenter({ map, lat, lng }) {
  return new Promise(resolve => {
    map.setCenter(new google.maps.LatLng(lat, lng));

    return resolve();
  });
}
